import axios from 'axios';

const api = axios.create({ baseURL: 'https://sellerdash-production.up.railway.app/api' });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const auth = {
  register: (data) => api.post('/auth/register', data).then(r => r.data),
  login: (data) => api.post('/auth/login', data).then(r => r.data),
  me: () => api.get('/auth/me').then(r => r.data),
};

export const amazon = {
  getAccounts: () => api.get('/amazon/accounts').then(r => r.data),
  connect: (marketplace_id) => api.get('/amazon/connect', { params: { marketplace_id } }).then(r => r.data),
  connectSelf: (marketplace_id) => api.post('/amazon/connect-self', { marketplace_id }).then(r => r.data),
  disconnect: (id) => api.delete(`/amazon/accounts/${id}`).then(r => r.data),
};

export const dashboard = {
  summary: (accountId, days = 30) =>
    api.get(`/dashboard/${accountId}/summary`, { params: { days } }).then(r => r.data),
  salesDaily: (accountId, days = 30) =>
    api.get(`/dashboard/${accountId}/sales-daily`, { params: { days } }).then(r => r.data),
  inventory: (accountId) =>
    api.get(`/dashboard/${accountId}/inventory`).then(r => r.data),
  updateCogs: (accountId, sku, cogs_per_unit) =>
    api.patch(`/dashboard/${accountId}/inventory/${sku}/cogs`, { cogs_per_unit }).then(r => r.data),
  payout: (accountId) =>
    api.get(`/dashboard/${accountId}/payout`).then(r => r.data),
  sync: (accountId) =>
    api.post(`/dashboard/${accountId}/sync`).then(r => r.data),
  bsr: (accountId, asin, days) =>
    api.get(`/dashboard/${accountId}/bsr`, { params: { asin, days } }).then(r => r.data),
  addBsr: (accountId, data) =>
    api.post(`/dashboard/${accountId}/bsr`, data).then(r => r.data),
};

export const shipments = {
  list: (accountId) => api.get(`/shipments/${accountId}`).then(r => r.data),
  create: (accountId, data) => api.post(`/shipments/${accountId}`, data).then(r => r.data),
  update: (accountId, id, data) => api.patch(`/shipments/${accountId}/${id}`, data).then(r => r.data),
  remove: (accountId, id) => api.delete(`/shipments/${accountId}/${id}`).then(r => r.data),
};

export const billing = {
  checkout: () => api.post('/billing/create-checkout').then(r => r.data),
  portal: () => api.post('/billing/portal').then(r => r.data),
  status: () => api.get('/billing/status').then(r => r.data),
};

export const profit = {
  calculate: (accountId, data) =>
    api.post(`/profit/${accountId}/calculate`, data).then(r => r.data),
  report: (accountId, period) =>
    api.get(`/profit/${accountId}/report`, { params: { period } }).then(r => r.data),
};

export default api;